var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooksAe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9451_28958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5303 35.2544L17.2422 35.2544C17.0117 35.2544 16.7835 35.205 16.5707 35.1091C16.3578 35.0132 16.1644 34.8726 16.0016 34.6954C15.8388 34.5182 15.7098 34.3079 15.622 34.0765C15.5341 33.845 15.4892 33.5971 15.4897 33.3467V29.4496C15.4897 28.9559 15.6702 28.4824 15.9917 28.1332C16.3131 27.7841 16.749 27.588 17.2036 27.588L35.5303 27.588V35.2493V35.2544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.543004 30.7455V31.8983C0.540557 32.4846 0.66678 33.0632 0.911214 33.586C1.38207 34.5833 2.25316 35.2543 3.25326 35.2543H36.0673C36.2839 35.2543 36.46 35.0365 36.46 34.7674V34.5956C36.46 34.3266 36.2839 34.1087 36.0673 34.1087H16.0606C15.9511 33.9448 15.8565 33.7697 15.778 33.586C15.5829 33.1269 15.4826 32.627 15.4842 32.1213V30.6565C15.4841 30.3939 15.5112 30.1321 15.5652 29.8761C15.651 29.468 15.8087 29.0817 16.0295 28.7386H36.0673C36.2839 28.7386 36.46 28.5208 36.46 28.2517V28.0799C36.46 27.8109 36.2839 27.593 36.0673 27.593H3.08846C1.92544 27.593 0.946057 28.5576 0.64 29.8761C0.574823 30.1604 0.542244 30.4525 0.543004 30.7455Z",
    fill: "#219CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5302 31.4236L33.1006 31.5525L35.5302 31.6302V31.4236Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5302 32.6255L29.75 32.7544L35.5302 32.8321V32.6255Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0693 19.0703L27.7812 19.0703C27.3165 19.0703 26.8707 18.8698 26.542 18.5128C26.2134 18.1558 26.0287 17.6716 26.0287 17.1667V13.2696C26.0287 12.7759 26.2093 12.3024 26.5307 11.9532C26.8521 11.6041 27.2881 11.408 27.7426 11.408L46.0693 11.408V19.0693V19.0703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 14.5668V15.7196C11.0817 16.3061 11.2076 16.8849 11.4513 17.4083C11.9222 18.4056 12.7942 19.0766 13.7943 19.0766H46.6074C46.7188 19.0682 46.8227 19.0123 46.8964 18.9212C46.9701 18.83 47.0077 18.7109 47.001 18.5897V18.4169C47.0077 18.2958 46.9701 18.1769 46.8964 18.0858C46.8226 17.9948 46.7187 17.9392 46.6074 17.931H26.6082C26.4994 17.7666 26.4049 17.5916 26.3257 17.4083C26.131 16.9491 26.031 16.4492 26.0328 15.9436V14.4727C26.0326 14.2104 26.0598 13.9489 26.1138 13.6933C26.1991 13.2851 26.3564 12.8989 26.5771 12.5558H46.6074C46.7188 12.5474 46.8227 12.4915 46.8964 12.4004C46.9701 12.3092 47.0077 12.1901 47.001 12.0689V11.8971C47.001 11.6281 46.8249 11.4092 46.6074 11.4092H13.6285C12.4665 11.4092 11.4861 12.3748 11.1801 13.6933C11.1149 13.979 11.0826 14.2724 11.084 14.5668Z",
    fill: "#219CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0702 15.2407L43.6406 15.3696L46.0702 15.4463V15.2407Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0703 16.4426L40.29 16.5715L46.0703 16.6492V16.4426Z",
    fill: "#A8BFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9451_28958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8027 35.2378H44.072C44.4181 35.2378 44.7501 35.3872 44.9949 35.653C45.2397 35.9189 45.3772 36.2795 45.3772 36.6555V39.6873C45.3772 40.0877 45.2308 40.4717 44.9701 40.7548C44.7094 41.038 44.3559 41.197 43.9872 41.197H25.8027V35.2378Z",
    fill: "#0054A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9451_28958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 35.2378H27.7055C28.0589 35.2378 28.3978 35.3903 28.6477 35.6617C28.8976 35.9331 29.038 36.3013 29.038 36.6852V39.7159C29.038 40.1085 28.8944 40.4849 28.6389 40.7625C28.3833 41.0401 28.0367 41.196 27.6753 41.196H7.13184V35.2378Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.483 40.3062H6.31676C6.20546 40.3062 6.11523 40.4042 6.11523 40.525V40.9782C6.11523 41.0991 6.20546 41.1971 6.31676 41.1971H30.483C30.5943 41.1971 30.6845 41.0991 30.6845 40.9782V40.525C30.6845 40.4042 30.5943 40.3062 30.483 40.3062Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.483 35.2378H6.31676C6.20546 35.2378 6.11523 35.3358 6.11523 35.4567V35.9098C6.11523 36.0307 6.20546 36.1287 6.31676 36.1287H30.483C30.5943 36.1287 30.6845 36.0307 30.6845 35.9098V35.4567C30.6845 35.3358 30.5943 35.2378 30.483 35.2378Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 38.2175L9.78747 38.3178L7.13184 38.3781V38.2175Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 36.8469L13.4507 36.9472L7.13184 37.0075V36.8469Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0532 36.8821C20.8761 37.0658 20.7513 37.3008 20.6935 37.5592C20.6766 37.6364 20.6671 37.7152 20.6652 37.7945C20.6501 38.354 20.6652 39.6193 20.6652 39.6193L19.8657 38.9861L19.0652 39.6193V37.9039C19.0563 37.6076 19.1242 37.3145 19.2611 37.058C19.2821 37.0116 19.3132 36.9714 19.3515 36.9408C19.3899 36.9102 19.4344 36.8901 19.4815 36.8821H21.0532Z",
    fill: "#739CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0534 36.8821C20.8763 37.0658 20.7515 37.3008 20.6937 37.5592L19.0928 37.5838C19.0928 37.5838 19.1559 36.9813 19.4864 36.8821H21.0534Z",
    fill: "#618BD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.835 27.6094L20.252 27.6094C19.7208 27.6094 19.2113 27.3802 18.8357 26.9721C18.46 26.5641 18.249 26.0107 18.249 25.4337V20.9801C18.249 20.4161 18.4553 19.8753 18.8224 19.4764C19.1896 19.0776 19.6876 18.8536 20.2068 18.8536H39.835V27.6094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2395 22.2507V24.1348C19.2443 24.9398 19.5983 25.6384 20.1201 26.0118C20.3776 26.1981 20.6798 26.298 20.9893 26.2992H41.4037C41.6429 26.2992 41.8369 26.5426 41.8369 26.8433V27.0653C41.8369 27.366 41.6429 27.6095 41.4037 27.6095H6.13749C5.12514 27.6095 4.23146 26.9784 3.68903 26.0118C3.33191 25.3627 3.14499 24.6199 3.14849 23.8637V22.3734C3.14796 21.8467 3.244 21.3251 3.431 20.8391C3.88491 19.6618 4.84357 18.8496 5.95668 18.8496H41.4037C41.6429 18.8496 41.8369 19.0931 41.8369 19.3928V19.6157C41.8369 19.9154 41.6429 20.1589 41.4037 20.1589H20.9271C20.6863 20.1635 20.4495 20.227 20.2345 20.3448C20.0194 20.4626 19.8316 20.6315 19.685 20.8391C19.394 21.2415 19.237 21.739 19.2395 22.2507Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8348 23.2314L37.2178 23.3787L39.8348 23.4677V23.2314Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8341 21.2163L33.6084 21.3636L39.8341 21.4526V21.2163Z",
    fill: "#B9CAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0693 21.3341C20.0693 21.3341 20.4799 21.6123 20.6165 22.0685C20.6414 22.1509 20.6557 22.2366 20.6588 22.3232C20.6814 22.9298 20.6588 24.3024 20.6588 24.3024L21.8718 23.6161L23.0819 24.3024V22.4429C23.0914 22.1067 22.9857 21.7786 22.7852 21.5223C22.7445 21.4671 22.6937 21.4217 22.636 21.389C22.5783 21.3562 22.5149 21.3368 22.45 21.332L20.0693 21.3341Z",
    fill: "#EB9A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0693 21.334C20.0693 21.334 20.4799 21.6122 20.6165 22.0684L23.047 22.095C23.047 22.095 22.9529 21.4424 22.45 21.334H20.0693Z",
    fill: "#DE8140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5005 27.5667L45.2594 28.6212L43.6548 28.387L43.1265 29.8814L41.8994 29.9203L41.9173 30.5954L43.5587 30.5442L44.0588 29.1276L45.7284 29.371L46.0919 27.7835L45.5005 27.5667Z",
    fill: "#FF724F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9778 4.97175L22.4427 3.52413L21.096 3.20716C21.0616 3.19907 21.0297 3.18012 21.0042 3.15245C20.9787 3.12477 20.9604 3.08947 20.9515 3.05055C20.9426 3.01162 20.9433 2.97062 20.9537 2.93217C20.9641 2.89373 20.9837 2.85938 21.0103 2.833L22.0491 1.80284L21.8962 0.240851C21.8921 0.200659 21.8979 0.159948 21.913 0.123373C21.9282 0.0867973 21.952 0.0558325 21.9818 0.0340177C22.0116 0.0122028 22.0462 0.000418266 22.0816 1.09293e-05C22.117 -0.000396408 22.1518 0.0105899 22.182 0.0317141L23.3593 0.843752L24.6103 0.197553C24.6424 0.181098 24.6778 0.17518 24.7127 0.180462C24.7475 0.185744 24.7804 0.202018 24.8076 0.22746C24.8348 0.252902 24.8553 0.286507 24.8668 0.324511C24.8782 0.362516 24.8802 0.403417 24.8725 0.442635L24.5653 1.97113L25.4941 3.132C25.5177 3.16185 25.5336 3.19866 25.54 3.2383C25.5464 3.27793 25.543 3.31881 25.5301 3.35634C25.5173 3.39387 25.4955 3.42655 25.4673 3.45071C25.4391 3.47487 25.4056 3.48954 25.3705 3.49309L23.9938 3.6287L23.315 4.99462C23.2974 5.02919 23.2717 5.05749 23.2409 5.07639C23.2101 5.09528 23.1752 5.10403 23.1403 5.10166C23.1054 5.09929 23.0717 5.0859 23.043 5.06296C23.0143 5.04003 22.9918 5.00846 22.9778 4.97175Z",
    fill: "#0074E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9451_28958",
    x: 21.8027,
    y: 35.2378,
    width: 27.5742,
    height: 13.9592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9451_28958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9451_28958",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9451_28958",
    x: 3.13184,
    y: 35.2378,
    width: 29.9062,
    height: 13.9583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9451_28958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9451_28958",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9451_28958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksAe);
export default __webpack_public_path__ + "static/media/books-ae.ab2a902d775d91543e7a34f0ea6bc335.svg";
export { ForwardRef as ReactComponent };